import { SignIn } from "@clerk/clerk-react";
import { sharedStyles } from '../styles/sharedStyles';

const SignInPage = () => {
  return (
    <div >
      <SignIn 
      />
    </div>
  );
};

export default SignInPage; 